/**
 * Thrown by apiFetch when there is no authorization (401).
 */
export default class UnauthorizedError extends Error {
    constructor(message = "Unauthorized") {
        super(message);
    }
}
